import * as Icons from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(
  Icons['faCalendar'],
  Icons['faLocationArrow'],
  Icons['faChartLine'],
  Icons['faSignInAlt'],
  Icons['faSignOutAlt'],
  Icons['faListOl'],
  Icons['faListUl'],
  Icons['faFilter'],
  Icons['faPlusCircle'],
  Icons['faTimes'],
  Icons['faBars'],
  Icons['faTachometerAlt'],
  Icons['faAtom'],
  Icons['faBoxes'],
  Icons['faExpand'],
  Icons['faPencilAlt'],
  Icons['faCogs'],
  Icons['faExternalLinkAlt'],
  Icons['faTrashAlt'],
  Icons['faColumns'],
  Icons['faStore'],
  Icons['faSignOutAlt'],
  Icons['faAtom'],
  Icons['faDollarSign'],
  Icons['faHandSpock'],
  Icons['faAngleRight'],
  Icons['faAngleDown'],
  Icons['faBuilding'],
  Icons['faUserFriends'],
  Icons['faUserClock'],
  Icons['faClipboardList'],
  Icons['faTruck'],
  Icons['faScrewdriver'],
  Icons['faHardHat'],
  Icons['faBiohazard'],
  Icons['faPaperclip'],
  Icons['faPencilAlt'],
  Icons['faCalendarAlt'],
  Icons['faCalendarCheck'],
  Icons['faCalendarWeek'],
  Icons['faClipboardCheck'],
  Icons['faBullhorn'],
  Icons['faGamepad'],
  Icons['faBed'],
  Icons['faUsersCog'],
  Icons['faUsers'],
  Icons['faBookOpen'],
  Icons['faShieldAlt'],
  Icons['faUserSecret'],
  Icons['faCog'],
  Icons['faExpand'],
  Icons['faCompress'],
  Icons['faPlus'],
  Icons['faSignOutAlt'],
  Icons['faUser'],
  Icons['faInfo'],
  Icons['faFileExcel'],
  Icons['faFilePdf'],
  Icons['faKey'],
  Icons['faClone']
)

export const bootstrap = async () => {
  //
}
